import React from "react";
import ConfigurationMaster from "./ConfigurationMaster";

function MaintenanceWindow() {
    return (
        <ConfigurationMaster
            type="maintenancewindow"
        />
    );
}

export default MaintenanceWindow;